import { render, staticRenderFns } from "./RetrievalDetailsView.vue?vue&type=template&id=60243e8c"
import script from "./RetrievalDetailsView.vue?vue&type=script&lang=js"
export * from "./RetrievalDetailsView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports